import { Col, Row, Tabs } from "antd";
import React, { useEffect } from "react";
import "../../assets/style/pageStyle/store.scss";
import { useDispatch, useSelector } from "react-redux";
import {
  resetState,
  resetStatus,
  setOpenModalGetLogStore,
} from "../../services/slice/StoreSlice";
import { storeProductSelector } from "../../services/selector/index.";
import Notify from "../../components/common/Notify";
import { useTranslation } from "react-i18next";
import NoSearchResults from "../../components/common/NoSearchResults";
import { useState } from "react";
import TableStatistics from "../../components/common/Table/TableStatistics";
import HeaderSortNews from "../../components/common/HeaderSortNews";
import ModalEditProduct from "../../components/common/Modal/edit/ModalEditProduct";
import ModalPreviewProduct from "../../components/common/Modal/getDetail/ModalPreviewProduct";
import ModalAddProduct from "../../components/common/Modal/add/ModalAddProduct";
import ModalGetLog from "../../components/common/Modal/getLog/ModalGetLog";
import TabAccessPost from "../../components/common/Tabs/TabAccessPost";
const Statistics = () => {
  const stateStore = useSelector(storeProductSelector);
  const [showPreview, setShowPreview] = useState(false);
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [valueSearch, setValueSearch] = useState("");
  const [type, setType] = useState(1);
  let currentPathname = window.location.pathname;
  const [tab, setTab] = useState(3);
  const [config, setConfig] = useState({
    search: "",
    typeSort: "timeCreate",
    type,
    option: {
      limit: 10,
      offset: 1,
      order: "desc",
    },
  });
  useEffect(() => {
    setType(currentPathname === "/news-statistics" ? 2 : 1);
    setConfig({
      search: "",
      typeSort: "timeCreate",
      option: {
        limit: 10,
        offset: 1,
        order: "desc",
      },
      type: currentPathname === "/news-statistics" ? 2 : 1,
    });
  }, [currentPathname]);
  useEffect(() => {
    return () => dispatch(resetState());
  }, []);

  const handleChangeTabs = (key) => {
    setTab(key);
  };

  return (
    <div className="wrapperStoreManager">
      {showPreview ? (
        <ModalPreviewProduct open={showPreview} setOpen={setShowPreview} />
      ) : null}
      {stateStore.isOpenModalAddProduct && (
        <ModalAddProduct title={"Thêm mới sản phẩm"} />
      )}
      {stateStore.isOpenModalEdit && <ModalEditProduct />}
      {stateStore.isOpenModalGetLog && (
        <ModalGetLog
          open={stateStore.isOpenModalGetLog}
          setOpen={setOpenModalGetLogStore}
          data={stateStore.dataLog}
        />
      )}
      <Notify
        isNotify={stateStore.isNotify}
        reset={resetStatus}
        title={"Bkav Pro"}
        content={stateStore.msg}
        type={stateStore.typeNotify}
      />
      <Tabs
        key={1}
        activeKey={tab}
        onChange={handleChangeTabs}
        items={[
          {
            label: t("Thống kê lượt tương tác"),
            key: 3,
            children: (
              <>
                <Row className="headerPage">
                  <HeaderSortNews
                    config={config}
                    // handleExport={exportReportBanner}
                    setValueSearch={setValueSearch}
                    title={
                      type === 1
                        ? "Thống kê tương tác của khách hàng với bài viết ưu đãi"
                        : "Thống kê tương tác của khách hàng với bài viết tin tức an ninh"
                    }
                    setConfig={setConfig}
                  />
                </Row>
                <Row>
                  {stateStore.config.search && !stateStore.data.length ? (
                    <NoSearchResults />
                  ) : (
                    <TableStatistics
                      type={type}
                      valueSearch={valueSearch}
                      setConfig={setConfig}
                      config={config}
                    />
                  )}
                </Row>
              </>
            ),
          },
          {
            label: t("Tình hình truy cập bài viết"),
            key: 1,
            children: (
              <>
                <TabAccessPost type={type} />
              </>
            ),
          },
        ]}
      />
    </div>
  );
};

export default Statistics;
